export default "__VITE_ASSET__0asBxGjm__"